import React from 'react';
import BaseComponent from 'components/BaseComponent';
import { VideoPreviewComponent, MusicPlayComponent, WebUrlPreview, PicturePreviewComponent } from '@/routes/Material/Util/index';
import 'components/Slider/index.less';
/** 在线预览组件 */
export class PreviewComponent extends BaseComponent {

    /** 预览类型判断 */
    isConcat = (arr, type) => {
        let flag = false;
        for (let item of arr) {
            if (item === type) {
                flag = true;
                break;
            }
        }
        return flag;
    }

    render() {
        const { type } = this.props;
        let paramProps = this.props;
        let arrPic = ['17', '1', '15', '16', '35'];     // 图片类型的预览
        let arrVideo = ['0', '14'];                     // 视频、直播源
        let arrMusic = ['2'];                           // 音乐
        let arrWebUrl = ['7'];                          // 网页

        // 视频、直播源预览
        if (this.isConcat(arrVideo, type)) {
            return (
                <VideoPreviewComponent {...paramProps} />
            )
        } 
        // 音乐预览
        else if (this.isConcat(arrMusic, type)) {
            return (
                <MusicPlayComponent {...paramProps} />
            )
        } 
        // 网页预览
        else if (this.isConcat(arrWebUrl, type)) {
            return (
                <WebUrlPreview {...paramProps} />
            )
        } 
        // 图片类型的预览
        else if (this.isConcat(arrPic, type)) {
            return (
                <PicturePreviewComponent {...paramProps} />
            )
        }
        return null;
    }

}




// WEBPACK FOOTER //
// ./src/routes/Material/Util/components/previewComponent.js